import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MovieService } from '../../services/movie.service';
import {HttpClient} from '@angular/common/http'
import { SeriesService } from '../../services/series.service';
import { UtilService } from '../../services/util.service';
import { map } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';


// declare var jwplayer: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
  @ViewChild('carousel', { static: false }) carousel!: ElementRef;

  isLoading: boolean = false;
  trendshowList: any;
  movieShowList:any;
  filteredMovie:any;
  HomeCardData:any=[]
  slideConfig = {
    "slidesToShow": 7, "slidesToScroll": 7,
     centerMode: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5
        }
      },
      {
        breakpoint:1024,
        settings:{
          slidesToShow:4,
          slidesToScroll:4
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  };
 
  categories: any;
  selectedcategory: any;
  isLocalData: any;
  loadMovies:boolean = false;
  loadSeries:boolean = false;
  seriesId:any
  //  jwplayer: any;
  page = 1;
  limit = 100;
  startX: number = 0;
  startY: number = 0;
  playlistid:any;
  profile_id:any;
  isLocal:boolean= true;

  constructor(
    private seriesService: SeriesService,
    private utilService: UtilService,
    private router: Router,
    private movieservice: MovieService,
    private http:HttpClient
  ) {
  }
  // /trendshowList
  ngOnInit(){
    this.checkPassword();
    //  const profileData = JSON.parse(localStorage.getItem('Profile'));
    //   const storedPlaylist = localStorage.getItem('playlist');
    // if (!storedPlaylist) return [];
    // const playlist = JSON.parse(storedPlaylist);
    // this.playlistid = playlist.id;
    // this.profile_id = profileData.profile_id;
    // if(this.utilService.isLocalProfile()){
    //   this.isLocal = true;
    // }else{
    //   this.isLocal = false;
    //   this.checkFav(this.profile_id)
    // }
  }

  checkPassword() {
    const encryptedPassword = localStorage.getItem('en_p');
    const key = 'purple_desktop_app@#$';
  
    if (encryptedPassword) {
      const bytes = CryptoJS.AES.decrypt(encryptedPassword, key);
      const decryptedPassword = bytes.toString(CryptoJS.enc.Utf8);
      console.log(decryptedPassword);
      
      return decryptedPassword;
    } else {
      console.log('No password found');
      return null;
    }
  }

  ngAfterViewInit(): void {
    // this.getAllMovie();
    // this.getSeriesCategory();
    // this.onCategorySelectLivetv('all');
    this.onCategorySelectMovies('all');
    this.onCategorySelectSeries('all');
    // this.getHomeData()
    // if(this.isLocal == true){
    //   this.checkFavLocal()
    //   console.log('local');
      
    // }
  }

  async onCategorySelectMovies(categoryId:string){
    this.page = 1;
    this.movieShowList = await this.movieservice.getAllMovies(this.page,this.limit)
    this.filteredMovie = this.movieShowList;
  }
  async onCategorySelectSeries(categoryId:string){
    this.page = 1;
    this.selectedcategory = await this.seriesService.getAllSeries(this.page,this.limit)
    console.log(this.selectedcategory);
  }

  async checkFavLocal() {
  const savedFavs = await this.movieservice.getFavoriteStreamIds(this.playlistid); // Array of stream_id
  const favSet = new Set(savedFavs); // 🔄 Convert to Set for O(1) lookup

  this.movieShowList = this.movieShowList.map(movie => ({
    ...movie,
    is_favorite: favSet.has(movie.stream_id) // ✅ Fast lookup
  }));

  this.filteredMovie = [...this.movieShowList];
}

checkFav(id:any){
    
  }
viewMovie(id:any){
this.router.navigate([`/series/info/+${id}`])
}

getHomeData()
{
  this.utilService.showSpinner()
  this.http.get('assets/homeCard/home.json').subscribe(res=>{
    this.utilService.hideSpinner()
   this.HomeCardData=res
    console.log(this.HomeCardData);
    
  })
}
  getSeriesCategory() {
    // this.utilService.showSpinner()
    this.isLoading = true;
    this.seriesService.getSeriesCategories().subscribe((res: any) => {
    // this.utilService.hideSpinner()
      this.isLoading = false;
      if(res.content){
        this.categories = res.content;
        if (this.categories.length > 0) {
          this.categories.map((ele: any, index) => {
            if (index == 0) {
              this.seriesId = ele.category_id;
              this.updateCategory(ele.category_id)
            }
          });
        }
      }else{
        this.categories = res;
        if (this.categories.length > 0) {
          this.categories.map((ele: any, index) => {
            if (index == 0) {
              this.seriesId = ele.category_id;
              this.updateCategory(ele.category_id)
            }
          });
        }
      }
    }, err => {
      this.loadSeries = true;
      this.isLoading = false;
      this.utilService.showErrorCall(err);
    });
  }

  loadSeriesData(){
    this.isLoading =true;
    this.seriesService.selectedCategoryWiseSeriesList(this.seriesId).subscribe((res: any) => {
      // this.utilService.hideSpinner()
        // this.isLoading = false;
        if (res.content){
          this.isLoading = false;
          this.loadSeries = false
          this.selectedcategory = res.content;    
        }
          else{
          this.isLoading = false;
          this.loadSeries = false
          this.selectedcategory = res.slice(0,150);
        }
      }, err => {
        this.loadSeries = true;
        this.isLoading = false;
        this.utilService.showErrorCall(err);
      });
  }


  updateCategory(id) {
    // this.isLoading = true;
    // this.utilService.showSpinner()
    this.seriesService.selectedCategoryWiseSeriesList(id).subscribe((res: any) => {
    // this.utilService.hideSpinner()
      // this.isLoading = false;
      if (res.content){
        this.loadSeries = false;
        this.selectedcategory = res.content
      }
      else {
        this.loadSeries = false;
        this.selectedcategory = res.slice(0,150);
      }
    }, err => {
      this.loadSeries = true;
      this.isLoading = false;
      this.utilService.showErrorCall(err);
    });

  }

  getAllMovie() {
    this.isLoading = true;
    this.utilService.showSpinner()
    this.movieservice.getMovieStreamList().subscribe((res: any) => {
      this.utilService.hideSpinner()
      this.isLoading = false;
      if(res.content){
        this.movieShowList = res.content;
      }else{
        this.movieShowList = res.slice(0,500);
      }
      if(this.movieShowList.user_info.auth === 0){
        this.utilService.showErrorToast("Something Went Wrong!")
       this.router.navigate(['/Qr-login'])
       localStorage.clear()
      }
    }, err => {
    this.utilService.hideSpinner()
    this.isLoading = false;
    this.loadMovies = true;
    this.utilService.showErrorCall(err);
    });

  }

  loadMovie(){
    this.isLoading =true
    this.movieservice.getMovieStreamList().subscribe((res: any) => {
      if(res){
        this.isLoading = false;
        this.utilService.hideSpinner()
        this.utilService.showSuccess("Movies loaded successfully")
        if(res.content){
          this.movieShowList = res.content;
          this.loadMovies = false

        }else{
          this.movieShowList = res.slice(0,500);
          this.loadMovies = false
        }
      }
      if(this.movieShowList.user_info.auth === 0){
        this.utilService.showErrorToast("Something Went Wrong!")
       this.router.navigate(['/Qr-login'])
       localStorage.clear()
      }
    }, err => {
    this.utilService.hideSpinner()
      this.isLoading = false;
      this.utilService.showErrorCall(err);
    });
  }


    /////////////////////////
  // playMovie(movieId) {
  //   const url = this.router.serializeUrl(
  //     this.router.createUrlTree(['/movies/watch/' + movieId])
  //   );
  //   window.open(url, '_blank');
  // }
  // playMovie(id: any, extension: any) {
  //   let stream_Url = this.movieService.getStremMovieUrl(id, extension);
  //   console.log(stream_Url);

  //   const player = jwplayer("myElement").setup({
  //     "playlist": [{
  //       // "file": "http://techslides.com/demos/sample-videos/small.mp4"
  //       "file": stream_Url
  //     }]
  //   });
  // }

scrollCarousel(direction: 'prev' | 'next') {
  const element = this.carousel.nativeElement as HTMLElement;
  const scrollAmount = 160 * 3; // Approx 3 cards width

  if (direction === 'next') {
    element.scrollLeft += scrollAmount;
  } else {
    element.scrollLeft -= scrollAmount;
  }
}
// onMouseDown(event: MouseEvent | TouchEvent): void {
//   const e = event instanceof TouchEvent ? event.touches[0] : event;
//   this.startX = e.clientX;
//   this.startY = e.clientY;
// }
onMouseDown(event: MouseEvent | TouchEvent): void {
  const isTouch = typeof TouchEvent !== 'undefined' && event instanceof TouchEvent;
  const e = isTouch ? event.touches[0] : event as MouseEvent;
  this.startX = e.clientX;
  this.startY = e.clientY;
}
onMouseUp(event: MouseEvent | TouchEvent, select: any): void {
  const isTouch = typeof TouchEvent !== 'undefined' && event instanceof TouchEvent;
  const e = isTouch ? event.changedTouches[0] : event as MouseEvent;
  const dx = Math.abs(e.clientX - this.startX);
  const dy = Math.abs(e.clientY - this.startY);

  if (dx < 10 && dy < 10) {
    this.router.navigate(['/movies/info', select.stream_id], {
      queryParams: { movieBy: 'search' }
    });
  }
}


onMouseUpSeries(event: MouseEvent | TouchEvent, select: any): void {
  const isTouch = typeof TouchEvent !== 'undefined' && event instanceof TouchEvent;
  const e = isTouch ? event.changedTouches[0] : event as MouseEvent;
  const dx = Math.abs(e.clientX - this.startX);
  const dy = Math.abs(e.clientY - this.startY);

  if (dx < 10 && dy < 10) {
    this.router.navigate(['/series/info', select.series_id]);
  }
}


}
